import React from "react";
import TimeRecommendListView from "./TimeRecommendListView";
import { TimeRecommendListProps } from "./type";

function TimeRecommendList(props: TimeRecommendListProps) {
  return <TimeRecommendListView props={props} />;
}
export default React.memo(TimeRecommendList);
